// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internalModal_modalContainer__kUjNN {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 200;
  background-color: var(--bg-backdrop);
  backdrop-filter: blur(2px);
}

.internalModal_modal__WegkR {
  width: min(720px, 96vw);
  max-height: min(80vh, 900px);
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  background: var(--bg-raised);
  color: var(--text-primary);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.55), 0 2px 6px rgba(0, 0, 0, 0.35);
}

.internalModal_header__OWALS {
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.internalModal_title__Qdaem {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
}

.internalModal_body__8dYze {
  padding: 14px 16px;
  overflow: auto;
}

.internalModal_footer__woHdh {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.internalModal_secondaryButton__J1UJs {
  background: transparent;
  border: none;
  color: var(--text-muted);
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
}

.internalModal_cancelIcon__-UjCq {
  filter: var(--text-muted-filter);
  width: 20px;
  height: 20px;
}

.internalModal_cancelIcon__-UjCq:hover {
  filter: var(--text-primary-filter);
}`, "",{"version":3,"sources":["webpack://./src/internal/components/internal-modal/internalModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,YAAA;EAEA,oCAAA;EACA,0BAAA;AAFF;;AAKA;EACE,uBAAA;EACA,4BAAA;EAEA,aAAA;EACA,sBAAA;EAEA,mBAAA;EAEA,4BAAA;EACA,0BAAA;EAEA,yEACE;AAPJ;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AARF;;AAWA;EACE,kBAAA;EACA,cAAA;AARF;;AAWA;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AARF;;AAWA;EACE,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AARF;;AAYA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;AATF;;AAYA;EACE,kCAAA;AATF","sourcesContent":[".modalContainer {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 20px;\n  z-index: 200;\n\n  background-color: var(--bg-backdrop);\n  backdrop-filter: blur(2px);\n}\n\n.modal {\n  width: min(720px, 96vw);\n  max-height: min(80vh, 900px);\n\n  display: flex;\n  flex-direction: column;\n\n  border-radius: 12px;\n\n  background: var(--bg-raised);\n  color: var(--text-primary);\n\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.55),\n    0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n.header {\n  padding: 14px 16px;\n  display: flex;\n  justify-content: space-between; \n  align-items: center;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.body {\n  padding: 14px 16px;\n  overflow: auto;\n}\n\n.footer {\n  padding: 12px 16px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.secondaryButton {\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  border-radius: 10px;\n  padding: 8px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n\n.cancelIcon {\n  filter: var(--text-muted-filter);\n  width: 20px;\n  height: 20px;\n}\n\n.cancelIcon:hover {\n  filter: var(--text-primary-filter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": `internalModal_modalContainer__kUjNN`,
	"modal": `internalModal_modal__WegkR`,
	"header": `internalModal_header__OWALS`,
	"title": `internalModal_title__Qdaem`,
	"body": `internalModal_body__8dYze`,
	"footer": `internalModal_footer__woHdh`,
	"secondaryButton": `internalModal_secondaryButton__J1UJs`,
	"cancelIcon": `internalModal_cancelIcon__-UjCq`
};
export default ___CSS_LOADER_EXPORT___;
